import { render, staticRenderFns } from "./MoleculeFiltersPins3D.vue?vue&type=template&id=73f96b6d&"
import script from "./MoleculeFiltersPins3D.vue?vue&type=script&lang=js&"
export * from "./MoleculeFiltersPins3D.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeFiltersPins3D.vue?vue&type=style&index=0&id=73f96b6d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeFiltersPins3D.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fcommon%2FMoleculeFiltersPins3D.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
